import { XIcon } from 'lucide-react'

import { cn } from '../../lib/utils'

export interface LabelPillProps {
  label: string
  /** Highlight when this label is an active filter selection. */
  active?: boolean
  onRemove?: () => void
  className?: string
}

/**
 * Free-form org label chip (Configure / Insights). Distinct from SCADA
 * registry tags — these are organizational taxonomy labels.
 */
export function LabelPill({ label, active = false, onRemove, className }: LabelPillProps) {
  return (
    <span
      className={cn(
        'inline-flex h-4.75 shrink-0 items-center gap-1 rounded-full border px-1.5 text-11 font-medium whitespace-nowrap',
        active ? 'border-brand/40 bg-brand-soft text-brand' : 'border-line bg-bg-sunk text-ink-2',
        onRemove && 'pr-1',
        className
      )}
    >
      {label}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
          aria-label={`Remove label ${label}`}
          className="inline-flex size-3.75 cursor-pointer items-center justify-center rounded-full opacity-60 hover:bg-accent hover:opacity-100"
        >
          <XIcon className="size-2.5" aria-hidden />
        </button>
      )}
    </span>
  )
}
